import { MapsTemp } from './map-functions-temp';
import { ROAD } from './constants';
import { DegenRaceway } from './degen-raceway';

export const StackPlazaOptions: { id: MapsTemp } & Record<string, any> = {
  id: 'stackPlaza',
  spriteSuffix: '_stacks.png',
  backgroundSuffix: '_StacksPlaza.png',
  COLORS: {
    SKY: '#6ab89d',
    TREE: '#4a4edf',
    FOG: '#000040',
    LIGHT: { road: '#6c7079', grass: '#808080', rumble: '#9c6e2f', lane: '#b98b4f' },
    DARK: { road: '#676775', grass: '#4d4d4d', rumble: '#b98b4f' },
    START: { road: '#a0a6a2', grass: '#a0a6a2', rumble: '#a0a6a2' },
    FINISH: { road: 'black', grass: 'black', rumble: 'black' },
  },
  BACKGROUND: {
    HILLS: { x: 5, y: 5, w: 1285, h: 480 },
    SKY: { x: 5, y: 495, w: 1285, h: 480 },
    TREES: { x: 5, y: 985, w: 1285, h: 480 },
  },
  SPRITES: {
    PALM_TREE: { x: 1, y: 1, w: 217, h: 521 },
    BILLBOARD08: { x: 651, y: 924, w: 524, h: 350 },
    TREE1: { x: 930, y: 0, w: 407, h: 397 },
    DEAD_TREE1: { x: 0, y: 522, w: 213, h: 484 },
    BILLBOARD09: { x: 685, y: 1291, w: 467, h: 384 },
    BOULDER3: { x: 483, y: 43, w: 456, h: 305 },
    COLUMN: { x: 1357, y: 0, w: 293, h: 404 },
    BILLBOARD01: { x: 636, y: 598, w: 567, h: 321 },
    BILLBOARD06: { x: 1228, y: 958, w: 523, h: 343 },
    BILLBOARD05: { x: 1221, y: 600, w: 538, h: 345 },
    BILLBOARD07: { x: 1213, y: 1307, w: 562, h: 350 },
    BOULDER2: { x: 300, y: 400, w: 360, h: 170 },
    TREE2: { x: 1670, y: 0, w: 328, h: 336 },
    BILLBOARD04: { x: 1635, y: 410, w: 361, h: 169 },
    DEAD_TREE2: { x: 235, y: 0, w: 250, h: 360 },
    BOULDER1: { x: 220, y: 630, w: 236, h: 347 },
    BUSH1: { x: 10, y: 1025, w: 273, h: 168 },
    CACTUS: { x: 780, y: 410, w: 330, h: 165 },
    BUSH2: { x: 1126, y: 415, w: 245, h: 160 },
    STUMP: { x: 1384, y: 410, w: 250, h: 175 },
    SEMI: { x: 1777, y: 670, w: 215, h: 254 },
    TRUCK: { x: 1776, y: 941, w: 178, h: 139 },
    CAR03: { x: 1808, y: 1146, w: 158, h: 96 },
    CAR02: { x: 1808, y: 1260, w: 141, h: 104 },
    CAR04: { x: 1808, y: 1381, w: 142, h: 102 },
    CAR01: { x: 1804, y: 1517, w: 139, h: 100 },
    SCALE: 0.3 * (1 / 84), // the reference sprite width should be 1/3rd the (half-)roadWidth
  },
  CAR_SCALE: 1 / 4,
  BASIC_CARS_SCALE: 1 / 1.7,
  totalCars: 180,

  // TODO(andrei): We can do this better by having all these props in each map insteaad of computing
  // carProps: (segmentLength, step) => {
  //   var maxSpeed = segmentLength / step; // top speed (ensure we can't move more than 1 segment in a single frame to make collision detection easier)
  //   var accel = maxSpeed / 3.5; // acceleration rate - tuned until it 'felt' right
  //   var breaking = -maxSpeed * 1.3; // deceleration rate when braking
  //   return { maxSpeed, accel, breaking };
  // },
  sCurves: [
    [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.MEDIUM, -ROAD.HILL.HIGH],
    [ROAD.LENGTH.SHORT, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.LONG, ROAD.CURVE.MEDIUM, -ROAD.HILL.MEDIUM],
    [ROAD.LENGTH.LONG, ROAD.LENGTH.LONG, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.MEDIUM, ROAD.HILL.MEDIUM],
    [ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.LENGTH.SHORT, ROAD.CURVE.MEDIUM, -1 * ROAD.HILL.HIGH],
    [ROAD.LENGTH.LONG, ROAD.LENGTH.MEDIUM, ROAD.LENGTH.MEDIUM, -ROAD.CURVE.EASY, 1 * ROAD.HILL.HIGH],
    [ROAD.LENGTH.MEDIUM, ROAD.LENGTH.LONG, ROAD.LENGTH.MEDIUM, ROAD.CURVE.MEDIUM, ROAD.HILL.LOW],
  ],
  // resetSprites: (SPRITES) => {
  //   var n, i;
  //
  //   addSprite(20, SPRITES.BILLBOARD05, 1);
  //   addSprite(40, SPRITES.BILLBOARD04, 1);
  //   addSprite(60, SPRITES.BILLBOARD06, 1);
  //   addSprite(80, SPRITES.BILLBOARD01, 1);
  //   addSprite(110, SPRITES.BILLBOARD08, 1);
  //   addSprite(150, SPRITES.BILLBOARD09, 1);
  //
  //   addSprite(20, SPRITES.BILLBOARD05, -1);
  //   addSprite(40, SPRITES.BILLBOARD04, -1);
  //   addSprite(60, SPRITES.BILLBOARD06, -1);
  //   addSprite(80, SPRITES.BILLBOARD01, -1);
  //   addSprite(110, SPRITES.BILLBOARD08, -1);
  //   addSprite(150, SPRITES.BILLBOARD09, -1);
  //
  //   addSprite(240, SPRITES.BILLBOARD07, -1.2);
  //   addSprite(240, SPRITES.BILLBOARD06, 1.2);
  //   addSprite(segments.length - 25, SPRITES.BILLBOARD07, -1.2);
  //   addSprite(segments.length - 25, SPRITES.BILLBOARD06, 1.2);
  //
  //   for (n = 250; n < 2000 && n < segments.length; n += 15) {
  //     addSprite(n, SPRITES.COLUMN, 1.1);
  //   }
  //
  //   for (n = 250; n < 2000 && n < segments.length; n += 25) {
  //     addSprite(n, SPRITES.COLUMN, -1.1);
  //   }
  //
  //   var side, sprite, offset;
  //   var min = segments.length - 50;
  //   if (3250 < min) min = 5000;
  //   for (n = 2000; n < min; n += 100) {
  //     side = Util.randomChoice([1, -1]);
  //     addSprite(n + Util.randomInt(0, 50), Util.randomChoice(SPRITES.BILLBOARDS), -side);
  //     for (i = 0; i < 20; i++) {
  //       sprite = Util.randomChoice(SPRITES.PLANTS);
  //       offset = side * (1.5 + Math.random());
  //       addSprite(n + Util.randomInt(0, 50), sprite, offset);
  //     }
  //   }
  //
  //   for (n = 3300; n < 5000 && n < segments.length; n += 20) {
  //     addSprite(n, SPRITES.COLUMN, 1.1);
  //   }
  //
  //   for (n = 3300; n < 5000 && n < segments.length; n += 17) {
  //     addSprite(n, SPRITES.COLUMN, -1.1);
  //   }
  //
  //   var side, sprite, offset;
  //   for (n = 5000; n < segments.length - 50; n += 100) {
  //     side = Util.randomChoice([1, -1]);
  //     addSprite(n + Util.randomInt(0, 50), Util.randomChoice(SPRITES.BILLBOARDS), -side);
  //     for (i = 0; i < 20; i++) {
  //       sprite = Util.randomChoice(SPRITES.PLANTS);
  //       offset = side * (1.5 + Math.random());
  //       addSprite(n + Util.randomInt(0, 50), sprite, offset);
  //     }
  //   }
  // },
  // Attention I changed the order of the params
  // addDownhillToEnd: (COLORS, num) => {
  //   num = num || 200;
  //   addRoad(num, num, num, ROAD.CURVE.MEDIUM, -lastY() / segmentLength, COLORS);
  // },
  nextGame: DegenRaceway,
};
